import React, { useEffect, useMemo, useState } from 'react';
import { adminListarSuscripciones, adminActualizarSuscripcion, PLANES, planPorClave, obtenerPagos, configurarPasarela } from '../services/membresiaService';
import { useToast } from '../context/ToastContext';
import { useAuth } from '../context/AuthContext';
import { adminEliminarNegocio, fechaEliminacion } from '../services/cuentaService';
import { adminSeguimientoPrueba, adminMarcarSeguimiento } from '../services/membresiaService';
import { ETAPAS, mensajeWhatsApp } from '../utils/seguimientoPrueba';
import { linkWhatsAppA } from '../utils/compartir';
import AdminPagosManuales from './AdminPagosManuales';
import AdminListaEspera from './AdminListaEspera';
import NumerosKontrolView from './NumerosKontrolView';
import AdminAyudaView from './AdminAyudaView';

const fecha = (f) => (f ? new Date(f).toLocaleDateString('es-HN', { day: 'numeric', month: 'short', year: 'numeric' }) : '—');

const ACCIONES = [
  { clave: 'activar_mensual', txt: 'Activar 1 mes', pidePlan: true },
  { clave: 'activar_anual', txt: 'Activar 1 año', pidePlan: true },
  { clave: 'extender_prueba', txt: '+7 días de prueba' },
  { clave: 'cortesia', txt: 'Cortesía VIP' },
  { clave: 'cambiar_plan', txt: 'Cambiar plan', pidePlan: true },
  { clave: 'pausar', txt: 'Pausar' },
  { clave: 'reservar_fundador', txt: '🏅 Reservar fundador (tester)', pidePlan: true },
  { clave: 'quitar_fundador', txt: 'Quitar fundador' },
  { clave: 'archivar', txt: 'Archivar', soloVisible: true },
  { clave: 'desarchivar', txt: 'Desarchivar', soloArchivada: true },
];

// Panel de la ADMIN de Kontrol: ver todas las cuentas y activar/pausar/regalar
// planes. La BD rechaza estas funciones a cualquiera que no sea admin.
export default function AdminSuscripcionesView({ onVolver }) {
  const { mostrarToast } = useToast();
  const { negocio, recargarSuscripcion } = useAuth();
  const [filas, setFilas] = useState(null);
  const [error, setError] = useState(null);
  const [filtro, setFiltro] = useState('');
  const [verArchivadas, setVerArchivadas] = useState(false);
  const [editando, setEditando] = useState(null); // { fila, accion, plan, notas }
  const [guardando, setGuardando] = useState(false);
  const [pagos, setPagos] = useState([]);
  const [configurando, setConfigurando] = useState(false);
  // "Para escribir hoy": cuentas en día 1-3, 7-9 o 12-14 de su prueba.
  const [seguimiento, setSeguimiento] = useState([]);
  const cargarSeguimiento = () => adminSeguimientoPrueba().then(setSeguimiento).catch(() => {});
  useEffect(() => { cargarSeguimiento(); }, []);
  const escribir = async (s) => {
    window.open(linkWhatsAppA(s.telefono, mensajeWhatsApp(s.etapa, s.negocio)), '_blank', 'noopener,noreferrer');
    try { await adminMarcarSeguimiento(s.negocio_id, s.etapa); cargarSeguimiento(); } catch { /* se puede marcar luego */ }
  };
  const [borrando, setBorrando] = useState(null); // negocio_id con la confirmación de borrado abierta
  const [textoBorrar, setTextoBorrar] = useState('');
  const [verNumeros, setVerNumeros] = useState(false); // 📊 Números de Kontrol
  const [verAyuda, setVerAyuda] = useState(false); // 🧰 Herramientas y Ayuda

  // Eliminación definitiva (solo después de los 30 días de la solicitud).
  const eliminarDefinitivo = async (f) => {
    try {
      const r = await adminEliminarNegocio(f.negocio_id);
      mostrarToast(`Negocio eliminado: ${r.fotos} foto(s) y ${r.usuarios} usuario(s) borrados.`, 'exito', 7000);
      setBorrando(null); setTextoBorrar('');
      cargar();
    } catch (e) { mostrarToast(e.message, 'error', 7000); }
  };
  const [resultadoConfig, setResultadoConfig] = useState(null);
  useEffect(() => { obtenerPagos(false).then(setPagos).catch(() => {}); }, []);

  // Una sola vez, con las claves de Tilopay ya puestas en Vercel.
  const configurar = async () => {
    setConfigurando(true);
    try { setResultadoConfig(await configurarPasarela()); }
    catch (e) { setResultadoConfig({ creados: [], errores: [e.message] }); }
    setConfigurando(false);
  };

  const cargar = async () => {
    try { setFilas(await adminListarSuscripciones()); setError(null); }
    catch (e) { setError(String(e?.message || '').includes('NO_AUTORIZADO') ? 'Solo la administradora de Kontrol puede ver esto.' : 'No se pudo cargar la lista.'); }
  };
  useEffect(() => { cargar(); }, []);

  const lista = useMemo(() => {
    const q = filtro.trim().toLowerCase();
    return (filas || []).filter((f) => !!f.archivada === verArchivadas && (!q || `${f.negocio} ${f.correo}`.toLowerCase().includes(q)));
  }, [filas, filtro, verArchivadas]);
  const totalArchivadas = (filas || []).filter((f) => f.archivada).length;

  const conteo = useMemo(() => {
    const c = { prueba: 0, activa: 0, cortesia: 0, pausadas: 0 };
    (filas || []).forEach((f) => {
      if (f.archivada) return;
      if (!f.vigente) c.pausadas++;
      else if (f.estado === 'activa') c.activa++;
      else if (f.estado === 'cortesia') c.cortesia++;
      else if (f.estado === 'prueba') c.prueba++;
    });
    return c;
  }, [filas]);

  const confirmar = async () => {
    setGuardando(true);
    try {
      await adminActualizarSuscripcion(editando.fila.negocio_id, editando.accion, editando.plan, editando.notas);
      mostrarToast('Cuenta actualizada ✅', 'exito');
      if (editando.fila.negocio_id === negocio?.id) recargarSuscripcion();
      setEditando(null);
      cargar();
    } catch (e) {
      mostrarToast(String(e?.message || '').includes('SIN_CUPOS') ? 'Ya no quedan cupos fundador (25 de 25).' : 'No se pudo actualizar: ' + (e?.message || 'error'), 'error');
    } finally { setGuardando(false); }
  };

  const etiquetaEstado = (f) => {
    if (f.archivada) return { txt: 'Archivada', c: '#4B5563', b: '#F3F4F6' };
    if (!f.vigente) return { txt: 'Pausada', c: '#B91C1C', b: '#FEF2F2' };
    if (f.estado === 'cortesia') return { txt: 'Cortesía', c: '#A16207', b: '#FEF9C3' };
    if (f.estado === 'activa') return { txt: `Activa · ${planPorClave(f.plan)?.nombre || f.plan}`, c: '#047857', b: '#ECFDF5' };
    return { txt: 'Prueba', c: '#6D28D9', b: '#F5F3FF' };
  };

  if (verNumeros) return <NumerosKontrolView onVolver={() => setVerNumeros(false)} />;
  if (verAyuda) return <AdminAyudaView onVolver={() => setVerAyuda(false)} />;

  return (
    <div className="k-page">
      <div className="k-page-head">
        <h2 className="k-page-title">🛡️ Admin · Membresías</h2>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          <button onClick={() => setVerNumeros(true)} style={{ padding: '8px 14px', borderRadius: '10px', border: 'none', background: 'linear-gradient(90deg,#6D28D9,#DB2777)', color: 'white', fontWeight: 800, cursor: 'pointer' }}>📊 Números de Kontrol</button>
          <button onClick={() => setVerAyuda(true)} className="k-btn-soft" style={{ fontWeight: 800 }}>🧰 Herramientas y Ayuda</button>
          <button onClick={onVolver} className="k-btn-soft">← Volver</button>
        </div>
      </div>

      {error && <p style={{ color: '#991B1B', fontWeight: 600 }}>⚠️ {error}</p>}
      {!filas && !error && <p style={{ color: '#6B7280' }}>⏳ Cargando cuentas...</p>}

      {filas && (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '10px', marginBottom: '14px' }}>
            {[['🎁 En prueba', conteo.prueba], ['✅ Pagando', conteo.activa], ['💛 Cortesía', conteo.cortesia], ['⏸️ Pausadas', conteo.pausadas]].map(([t, n]) => (
              <div key={t} className="k-card" style={{ padding: '12px' }}>
                <div style={{ fontSize: '12px', color: '#6B7280', fontWeight: 600 }}>{t}</div>
                <div style={{ fontSize: '24px', fontWeight: 800 }}>{n}</div>
              </div>
            ))}
          </div>
          <AdminListaEspera />
          <AdminPagosManuales
            negocios={Object.fromEntries((filas || []).map((f) => [f.negocio_id, f]))}
            onCambio={(id) => { cargar(); obtenerPagos(false).then(setPagos).catch(() => {}); if (id === negocio?.id) recargarSuscripcion(); }} />
          <div className="k-card" style={{ padding: '14px', marginBottom: '14px' }}>
            <b>📲 Para escribir hoy · seguimiento de la prueba</b>
            {seguimiento.length === 0
              ? <p style={{ margin: '8px 0 0', fontSize: '13px', color: '#6B7280' }}>Hoy no hay a quién escribir. Aquí aparecen las cuentas en su día 1, 7 y 13 de prueba.</p>
              : seguimiento.map((s) => (
                <div key={s.negocio_id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', padding: '8px 0', borderTop: '1px solid #F3F0FA', flexWrap: 'wrap', fontSize: '13px' }}>
                  <span style={{ minWidth: 0 }}>
                    <b>{s.negocio}</b> · día {s.dia} · {ETAPAS[s.etapa]?.emoji} {ETAPAS[s.etapa]?.nombre}
                    <span style={{ display: 'block', color: '#6B7280' }}>{s.telefono || 'sin teléfono'} · {s.correo || 'sin correo'}{s.correo_hecho ? ' · ✉️ correo enviado' : ''}</span>
                  </span>
                  {s.whatsapp_hecho
                    ? <span style={{ color: '#047857', fontWeight: 700 }}>✅ Ya le escribiste</span>
                    : s.telefono
                      ? <button onClick={() => escribir(s)} className="k-btn-soft" style={{ background: '#25D366', color: '#fff', border: 'none', fontWeight: 700 }}>Escribir por WhatsApp</button>
                      : <button onClick={async () => { await adminMarcarSeguimiento(s.negocio_id, s.etapa).catch(() => {}); cargarSeguimiento(); }} className="k-btn-soft">Marcar como hecho</button>}
                </div>
              ))}
          </div>
          <div className="k-card" style={{ padding: '14px', marginBottom: '14px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
              <b>💳 Pagos recientes · tarjeta (Tilopay) y manuales</b>
              <button className="k-btn-soft" onClick={configurar} disabled={configurando}>{configurando ? 'Configurando…' : 'Configurar pasarela'}</button>
            </div>
            {resultadoConfig && (
              <p style={{ margin: '8px 0 0', fontSize: '13px', color: resultadoConfig.errores?.length ? '#B91C1C' : '#047857' }}>
                {resultadoConfig.creados?.length || 0} planes de cobro creados.{resultadoConfig.errores?.length ? ' Errores: ' + resultadoConfig.errores.join(' | ') : ''}
              </p>
            )}
            {pagos.length === 0
              ? <p style={{ margin: '8px 0 0', fontSize: '13px', color: '#6B7280' }}>Todavía no hay pagos.</p>
              : pagos.slice(0, 10).map((x) => (
                <div key={x.id} style={{ display: 'flex', justifyContent: 'space-between', gap: '8px', padding: '7px 0', borderTop: '1px solid #F3F0FA', fontSize: '13px', flexWrap: 'wrap' }}>
                  <span>{fecha(x.creado_en)} · {x.correo || 'sin correo'} · {planPorClave(x.plan)?.nombre || '—'} {x.ciclo || ''}</span>
                  <span><b>{x.moneda === 'HNL' ? 'L' : '$'} {Number(x.monto).toLocaleString('es-HN')}</b>{' '}
                    <span style={{ fontWeight: 700, color: x.estado === 'aprobado' ? '#047857' : x.estado === 'revision' ? '#B45309' : '#B91C1C' }}>
                      {x.estado === 'revision' ? '⚠️ En revisión: ' + (x.motivo || '') : x.estado}
                    </span>
                  </span>
                </div>
              ))}
          </div>
          <div style={{ display: 'flex', gap: '8px', marginBottom: '12px', alignItems: 'center' }}>
            <input className="k-input" placeholder="Buscar negocio o correo..." value={filtro} onChange={(e) => setFiltro(e.target.value)} />
            <button className="k-btn-soft" style={{ whiteSpace: 'nowrap' }} onClick={() => setVerArchivadas((v) => !v)}>
              {verArchivadas ? '← Ver activas' : `🗄️ Ver archivadas (${totalArchivadas})`}
            </button>
          </div>
          {lista.length === 0 && <p style={{ color: '#6B7280', textAlign: 'center' }}>{verArchivadas ? 'No hay cuentas archivadas.' : 'No hay cuentas.'}</p>}

          <div style={{ display: 'grid', gap: '10px' }}>
            {lista.map((f) => {
              const e = etiquetaEstado(f);
              return (
                <div key={f.negocio_id} className="k-card" style={{ padding: '14px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px', flexWrap: 'wrap' }}>
                    <div style={{ minWidth: 0 }}>
                      <b>{f.negocio}</b>{f.precio_fundador && <span title="Precio fundador para siempre en este plan" style={{ marginLeft: '6px', fontSize: '12px', fontWeight: 700, color: '#A16207', background: '#FEF9C3', borderRadius: '999px', padding: '1px 8px' }}>🏅 Fundador{f.plan_fundador ? ` · ${planPorClave(f.plan_fundador)?.nombre || f.plan_fundador}` : ''}</span>}
                      <div style={{ fontSize: '13px', color: '#6B7280' }}>{f.correo || 'sin correo'} · creado {fecha(f.creado_en)}</div>
                      {f.eliminacion_solicitada_en && (() => {
                        const dia = fechaEliminacion(f.eliminacion_solicitada_en);
                        const listo = dia.getTime() <= Date.now();
                        return (
                          <div style={{ fontSize: '13px', color: '#991B1B', marginTop: '4px', fontWeight: 600 }}>
                            🗑️ Pidió eliminar su cuenta el {fecha(f.eliminacion_solicitada_en)}{f.eliminacion_motivo ? ` · "${f.eliminacion_motivo}"` : ''}
                            {' · '}{listo ? 'ya se puede eliminar' : `se puede eliminar desde el ${fecha(dia)}`}
                            {listo && borrando !== f.negocio_id && (
                              <button className="k-btn-soft" style={{ marginLeft: '8px', fontSize: '12px', padding: '4px 10px', color: '#B91C1C' }} onClick={() => { setBorrando(f.negocio_id); setTextoBorrar(''); }}>Eliminar definitivamente</button>
                            )}
                            {borrando === f.negocio_id && (
                              <span style={{ display: 'inline-flex', gap: '6px', marginLeft: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                                <input value={textoBorrar} onChange={(e) => setTextoBorrar(e.target.value)} placeholder="Escribe ELIMINAR" aria-label="Confirmar eliminación" style={{ padding: '4px 8px', border: '1px solid #FCA5A5', borderRadius: '6px', fontSize: '12px' }} />
                                <button disabled={textoBorrar.trim().toUpperCase() !== 'ELIMINAR'} onClick={() => eliminarDefinitivo(f)} style={{ padding: '4px 10px', border: 'none', borderRadius: '6px', background: textoBorrar.trim().toUpperCase() === 'ELIMINAR' ? '#B91C1C' : '#D1D5DB', color: '#fff', fontSize: '12px', fontWeight: 700, cursor: 'pointer' }}>Borrar todo</button>
                                <button onClick={() => setBorrando(null)} style={{ padding: '4px 10px', border: '1px solid #E5E7EB', borderRadius: '6px', background: '#fff', fontSize: '12px', cursor: 'pointer' }}>No</button>
                              </span>
                            )}
                          </div>
                        );
                      })()}
                      {f.renovacion_cancelada && (
                        <div style={{ fontSize: '13px', color: '#B45309', marginTop: '4px', fontWeight: 600 }}>
                          🚫 No renueva{f.motivo_cancelacion ? ` · "${f.motivo_cancelacion}"` : ''}
                          {f.proveedor_pago === 'tilopay' && ' · ⚠️ Cancela también su suscripción en Tilopay'}
                        </div>
                      )}
                      <div style={{ fontSize: '13px', color: '#374151', marginTop: '4px' }}>
                        {f.estado === 'prueba' && `Prueba hasta ${fecha(f.prueba_hasta)}`}
                        {f.estado === 'activa' && `Pagado hasta ${fecha(f.pagado_hasta)} (${f.ciclo || '—'})`}
                        {f.notas ? ` · 📝 ${f.notas}` : ''}
                      </div>
                    </div>
                    <span style={{ alignSelf: 'flex-start', background: e.b, color: e.c, fontWeight: 700, borderRadius: '999px', padding: '3px 10px', fontSize: '12px' }}>{e.txt}</span>
                  </div>
                  <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginTop: '10px' }}>
                    {ACCIONES.filter((a) => (f.archivada ? !a.soloVisible : !a.soloArchivada)).map((a) => (
                      <button key={a.clave} className="k-btn-soft" style={{ fontSize: '12px', padding: '5px 10px' }}
                        onClick={() => setEditando({ fila: f, accion: a.clave, plan: f.plan || 'crece', notas: '' })}>
                        {a.txt}
                      </button>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}

      {editando && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', zIndex: 1000 }}>
          <div className="k-card" style={{ padding: '20px', width: '100%', maxWidth: '420px' }}>
            <h3 style={{ marginTop: 0 }}>{ACCIONES.find((a) => a.clave === editando.accion)?.txt}</h3>
            <p style={{ marginTop: 0, color: '#374151' }}><b>{editando.fila.negocio}</b><br /><span style={{ fontSize: '13px', color: '#6B7280' }}>{editando.fila.correo}</span></p>
            {ACCIONES.find((a) => a.clave === editando.accion)?.pidePlan && (
              <label style={{ display: 'block', marginBottom: '10px', fontSize: '13px', fontWeight: 600 }}>Plan
                <select className="k-input" value={editando.plan} onChange={(e) => setEditando({ ...editando, plan: e.target.value })} style={{ marginTop: '4px' }}>
                  {PLANES.map((p) => <option key={p.clave} value={p.clave}>{p.nombre}</option>)}
                </select>
              </label>
            )}
            <label style={{ display: 'block', marginBottom: '14px', fontSize: '13px', fontWeight: 600 }}>Nota (opcional)
              <input className="k-input" value={editando.notas} placeholder="Ej: pagó por transferencia BAC 5-oct" onChange={(e) => setEditando({ ...editando, notas: e.target.value })} style={{ marginTop: '4px' }} />
            </label>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button className="k-btn-soft" onClick={() => setEditando(null)} disabled={guardando}>Cancelar</button>
              <button className="k-btn-ghost" onClick={confirmar} disabled={guardando}>{guardando ? 'Guardando...' : 'Confirmar'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
